import { useEffect, useState } from 'react';

const SHARED_RATES_VERSION_STORAGE_KEY = 'quoting-shared-rates-version';

export function loadSharedRatesVersion() {
  try {
    const stored = localStorage.getItem(SHARED_RATES_VERSION_STORAGE_KEY);

    if (!stored) return null;

    const parsed = JSON.parse(stored);

    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return null;

    return parsed;
  } catch (error) {
    console.error('Failed to read shared rates version from localStorage:', error);
    return null;
  }
}

export function saveSharedRatesVersion(selectedRatesVersion) {
  try {
    localStorage.setItem(SHARED_RATES_VERSION_STORAGE_KEY, JSON.stringify(selectedRatesVersion));
  } catch (error) {
    console.error('Failed to persist shared rates version to localStorage:', error);
  }
}

/**
 * Selected rates-version-per-insurer, shared between the Quotation and Auto Quotation
 * pages through localStorage - the same way `useSharedClients` shares client rows -
 * so picking a version for an insurer on one page is reflected on the other.
 *
 * @param defaults per-insurer default version, used for any insurer not already stored.
 */
export function useSharedRatesVersion(defaults) {
  const [selectedRatesVersion, setSelectedRatesVersion] = useState(() => ({
    ...defaults,
    ...(loadSharedRatesVersion() || {})
  }));

  useEffect(() => {
    saveSharedRatesVersion(selectedRatesVersion);
  }, [selectedRatesVersion]);

  return [selectedRatesVersion, setSelectedRatesVersion];
}
